import React from "react";
import { Link } from "react-router-dom";
import _ from "lodash";
import Emojis from "./emojis/Emojis";
import Footer from "./Footer";
import Header from "./common/Header";

const emojis = require("./emojis/emojisLabel.json").emojis;

const Home = () => {
  const all = _.sampleSize(emojis, 12);
  const smileys = _.sampleSize(
    emojis.filter((emoji) => emoji.type === "smileys"),
    12
  );
  const objects = _.sampleSize(
    emojis.filter((emoji) => emoji.type === "Objects"),
    12
  );
  const symbols = _.sampleSize(
    emojis.filter((emoji) => emoji.type === "Symbols"),
    12
  );
  const travel = _.sampleSize(
    emojis.filter((emoji) => emoji.type === "Travel"),
    12
  );
  const food = _.sampleSize(
    emojis.filter((emoji) => emoji.type === "Food"),
    12
  );
  const animals = _.sampleSize(
    emojis.filter((emoji) => emoji.type === "Animals & nature"),
    12
  );
  const flags = _.sampleSize(
    emojis.filter((emoji) => emoji.type === "Flags"),
    12
  );

  return (
    <>
      <div className="app">
        <div className="container">
          <div>
            <Header />
            <div className="home">
              <Link to="/all">
                <div className="card">
                  <div className="emojis">
                    {all.map((item) => (
                      <div key={item.id} className="emoji">
                        <Emojis data={item.id} svg={true} />
                      </div>
                    ))}
                  </div>
                  <h3>All emojis</h3>
                </div>
              </Link>
              <Link to="/smileys">
                <div className="card">
                  <div className="emojis">
                    {smileys.map((item) => (
                      <div key={item.id} className="emoji">
                        <Emojis data={item.id} svg={true} />
                      </div>
                    ))}
                  </div>
                  <h3>Smileys and People</h3>
                </div>
              </Link>
              <Link to="/objects">
                <div className="card">
                  <div className="emojis">
                    {objects.map((item) => (
                      <div key={item.id} className="emoji">
                        <Emojis data={item.id} svg={true} />
                      </div>
                    ))}
                  </div>
                  <h3>Objects</h3>
                </div>
              </Link>
              <Link to="/symbols">
                <div className="card">
                  <div className="emojis">
                    {symbols.map((item) => (
                      <div key={item.id} className="emoji">
                        <Emojis data={item.id} svg={true} />
                      </div>
                    ))}
                  </div>
                  <h3>Symbols</h3>
                </div>
              </Link>

              <Link to="/travel">
                <div className="card">
                  <div className="emojis">
                    {travel.map((item) => (
                      <div key={item.id} className="emoji">
                        <Emojis data={item.id} svg={true} />
                      </div>
                    ))}
                  </div>
                  <h3>Travel & places</h3>
                </div>
              </Link>

              <Link to="/food">
                <div className="card">
                  <div className="emojis">
                    {food.map((item) => (
                      <div key={item.id} className="emoji">
                        <Emojis data={item.id} svg={true} />
                      </div>
                    ))}
                  </div>
                  <h3>Food and drinks</h3>
                </div>
              </Link>
              <Link to="/animals">
                <div className="card">
                  <div className="emojis">
                    {animals.map((item) => (
                      <div key={item.id} className="emoji">
                        <Emojis data={item.id} svg={true} />
                      </div>
                    ))}
                  </div>
                  <h3>Animals and nature</h3>
                </div>
              </Link>

              <Link to="/flags">
                <div className="card">
                  <div className="emojis">
                    {flags.map((item) => (
                      <div key={item.id} className="emoji">
                        <Emojis data={item.id} svg={true} />
                      </div>
                    ))}
                  </div>
                  <h3>Flags</h3>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Home;
